import {DICTIONARY} from './config';

export function interpret(label: string) {
    if (typeof DICTIONARY !== 'object' || DICTIONARY === null || !Object.keys(DICTIONARY).length) {
        return label;
    }

    if (!DICTIONARY.hasOwnProperty(label) || typeof DICTIONARY[label] !== 'string') {
        return label;
    }

    return DICTIONARY[label];
}
